<!-- 🔥 Diseño unificado según Figma -->
<div class="aviso" *ngIf="callerId.includes('685088956')">No contestar(Testing)</div>
<div class="call-card" [ngClass]="{
  'ringing': type === 'ringing',
  'in-call': type === 'inCall',
  'on-hold': type === 'onHold'
}">
  <!-- Barra vertical izquierda con color según estado -->
  <div class="status-indicator"></div>

  <!-- Contenido principal -->
  <div class="card-content">
    <!-- Header con nombre y badge -->
    <div class="card-header">
      <p class="caller-name">{{ getDisplayName() }}</p>
      <!-- Badge rojo circular con número de servicios activos -->
      <div class="services-badge" *ngIf="hasActiveServices()">
        {{ getActiveServicesCount() }}
      </div>
    </div>

    <!-- Footer con botones -->
    <div class="card-footer">
      <!-- Botón principal: Aceptar/Pausar/Retomar -->
      <button class="action-button main-button" (click)="onMainButtonClick()">
        <ion-icon [name]="getMainButtonIcon()"></ion-icon>
        <span>{{ getMainButtonText() }}</span>
      </button>

      <!-- Botón rechazar -->
      <button class="action-button reject-button" (click)="onHangup()">
        <ion-icon name="dp-close"></ion-icon>
      </button>

      <!-- Botón listado (solo visible si hay journeys) -->
      <button class="action-button list-button" *ngIf="hasJourneys()" (click)="onShowList()">
        <ion-icon name="list"></ion-icon>
      </button>
    </div>
  </div>
</div>